export default async function updateDocumento(repository, documento) {
  return repository.updateDocumento(documento);
}
